import { useState } from 'react';
import { Button, MenuItem, Grid, Box, Menu } from '@mui/material';
import { convertArrayToCSV } from 'convert-array-to-csv';
import DownloadIcon from '@mui/icons-material/Download';
import { TemplateUploader } from './TemplateUploader';
import { useSelector } from 'react-redux';
export const TemplateSelector = () => {
  const templates = useSelector(
    (state) => state.app.organization?.templates?.filter((template) => template.isActive) || [],
  );
  const states = useSelector((state) => state.app.prestobotsConfig?.states);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [dowleadedFile, setDowleadedFile] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElState, setAnchorElState] = useState(null);
  const open = Boolean(anchorEl);
  const handleCloseTemplate = (t) => {
    try {
      setAnchorEl(null);
      setSelectedTemplate(t);
      setDowleadedFile(false);
    } catch (error) {
      console.log(error);
    }
  };
  const handleTemplateChange = (event) => {
    try {
      const selectedTemplateId = event.target.value;
      const selectedTemplateName = templates.find((template) => template.id === selectedTemplateId);
      setAnchorEl(event.currentTarget);
      if (selectedTemplateId) {
        setSelectedTemplate(selectedTemplateName);
      }
    } catch (error) {
      console.log('handleTemplateChange', error);
      setSelectedTemplate([]);
    }
  };
  const handleCloseState = (t) => {
    try {
      console.log(t);
      setAnchorElState(null);
      setSelectedState(t);
      setDowleadedFile(false);
    } catch (error) {
      console.log('handleCloseState', error);
    }
  };
  const handleStateChange = (event) => {
    try {
      const selecetedStateKey = event.target.key;
      const selectedTemplateName = states.find((state) => state.key === selecetedStateKey);
      setAnchorElState(event.currentTarget);
      if (selecetedStateKey) {
        setSelectedState(selectedTemplateName);
      }
    } catch (error) {
      console.log('handleStateChange', error);
      setSelectedState([]);
    }
  };
  const handleDownload = () => {
    try {
      if (selectedTemplate) {
        const headers = ['phone', ...selectedTemplate.params];
        const data = ['5490000000000'];
        selectedTemplate.params.forEach((_, i) => {
          data.push(`valor ${i + 1}`);
        });
        const csvFromArrayOfArrays = convertArrayToCSV([data], {
          header: headers,
          separator: ';',
        });
        // eslint-disable-next-line no-undef
        const blob = new Blob([csvFromArrayOfArrays], { type: 'text/csv;charset=utf-8;' });
        // Crear una URL de objeto para el Blob
        const url = URL.createObjectURL(blob);
        // Crear un elemento de enlace de descarga
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.download = `${selectedTemplate.displayName}.csv`;
        // Simular el clic en el enlace para descargar el archivo
        link.click();
        // Liberar el objeto URL después de la descarga
        URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log('handleDownload error', error);
    }
  };
  return (
    <>
      <Grid container alignItems="center">
        <Grid item sm={12}>
          <Box>
            <label htmlFor="template-select">Selecciona un template:</label>
          </Box>
        </Grid>
        <Grid item>
          <Button
            disabled={!(templates && templates.length > 0)}
            variant={selectedTemplate && selectedTemplate.displayName ? 'contained' : 'outlined'}
            id="demo-positioned-button"
            aria-controls={open ? 'demo-positioned-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleTemplateChange}
          >
            {(selectedTemplate && selectedTemplate.displayName) || 'selecciona un template'}
          </Button>
          <Menu
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            open={open}
            onClose={handleCloseTemplate}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            {templates &&
              templates.map((template) => (
                <MenuItem
                  key={template.id}
                  value={template.displayName}
                  onClick={() => handleCloseTemplate(template)}
                >
                  {template.displayName}
                </MenuItem>
              ))}
          </Menu>
        </Grid>
        {selectedTemplate && selectedTemplate.displayName ? (
          <>
            <Grid sx={{ margin: '10px' }}>
              <Button
                disabled={!(states && states.length > 0)}
                variant={selectedState ? 'contained' : 'outlined'}
                aria-controls="demo-positioned-menu-state"
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleStateChange}
              >
                {(selectedState && selectedState.label) || 'Selecciona un estado'}
              </Button>
              <Menu
                id="demo-positioned-menu-state"
                anchorEl={anchorElState}
                open={Boolean(anchorElState)}
                onClose={handleCloseState}
              >
                {states &&
                  states
                    .filter((state) => state.label !== 'por hacer')
                    .map((state) => (
                      <MenuItem
                        key={state.key ? state.key : 1}
                        value={state.label}
                        onClick={(event) => handleCloseState(state)}
                      >
                        {state.label}
                      </MenuItem>
                    ))}
              </Menu>
            </Grid>
            {selectedState && selectedState.key && (
              <Grid item>
                <Box>
                  <Button
                    variant="contained"
                    disabled={dowleadedFile}
                    onClick={() => handleDownload()}
                    startIcon={<DownloadIcon />}
                  >
                    Descargar archivo cabecera
                  </Button>
                </Box>
              </Grid>
            )}
            {selectedState && (
              <TemplateUploader selectedTemplate={selectedTemplate} selectedState={selectedState} />
            )}
          </>
        ) : null}
      </Grid>
    </>
  );
};
